import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { submitContactForm } from '../../services/ContactService';
import './Pages.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  const [validated, setValidated] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await submitContactForm(formData);
      console.log('Form submitted successfully:', response);
      setSubmitted(true);
      setValidated(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      toast.success('Message sent successfully! We will get back to you soon.');
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error(error.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Container className="page-container">
      <Row className="page-header">
        <Col>
          <h1>Contact Us</h1>
          <div className="header-underline"></div>
        </Col>
      </Row>
      
      <Row className="page-content">
        <Col md={6} className="contact-info">
          <h2>Get in Touch</h2>
          <p>
            We'd love to hear from you! Whether you have a question about our products, 
            need help with an order, or want to discuss a custom design, our team is here to help.
          </p>
          
          <div className="contact-details">
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div>
                <h5>Phone</h5>
                <p>+91 9205894678</p>
              </div>
            </div>
            
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div>
                <h5>Email</h5>
                <p>info@nmdiamond.in</p>
              </div>
            </div>
            
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div>
                <h5>Address</h5>
                <p>3339,PVT NO.209,SECOND FLOOR, Bank St, Karol Bagh, New Delhi, Delhi 110005, India</p>
              </div>
            </div>
          </div>
          
          <div className="business-hours mt-4">
            <h5>Business Hours</h5>
            <p>Tuesday - Sunday: 10:00 AM - 8:00 PM<br />Monday: Closed</p>
          </div>
        </Col>
        
        <Col md={6} className="contact-form">
          {submitted ? (
            <div className="thank-you-message">
              <h3>Thank You!</h3>
              <p>Your message has been sent successfully. We'll get back to you as soon as possible.</p>
              <Button variant="outline-primary" onClick={() => setSubmitted(false)}>Send Another Message</Button>
            </div>
          ) : (
            <>
              <h2>Send Us a Message</h2>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                  <Form.Control.Feedback type="invalid">Please provide your name.</Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid email.</Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a subject.</Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a message.</Form.Control.Feedback>
                </Form.Group>
                
                <Button 
                  variant="primary" 
                  type="submit" 
                  className="w-100"
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send Message'}
                </Button>
              </Form>
            </>
          )}
        </Col>
      </Row>
      
      <Row className="mt-5">
        <Col>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.5752686321247!2d77.18744547556825!3d28.644876175677396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d029f33eb4801%3A0x10d400d1d7d6d9e9!2sBank%20St%2C%20Karol%20Bagh%2C%20New%20Delhi%2C%20Delhi%20110005!5e0!3m2!1sen!2sin!4v1710349498024!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="NM Diamond Location"
            ></iframe>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactUs; 